function multipleDownloadDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/multiple-download-dialog/multiple-download-dialog.html?$$REVISION$$'
  }
}
export { multipleDownloadDialog }
